import { NAMESPACE, useLang } from '@/hooks/use-lang';
import { Alert } from '../components';

interface IProps {
  failSkus: string[];
  className?: string;
  onClose: () => void;
}

export const PriceErrorMessage = ({ failSkus, className, onClose }: IProps) => {
  const { t } = useLang(NAMESPACE.common);

  return (
    <Alert
      className={className}
      onClose={onClose}
      open={failSkus.length > 0}
      type="warning"
      title=""
      content={<span dangerouslySetInnerHTML={{ __html: t('price.error', { skus: failSkus.join(', ') }) }}></span>}
    />
  );
};
